'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "ChoiceChildren": "Polaris-ChoiceList__ChoiceChildren"
};

exports.default = styles;
